/** Stripe-injected dev overlay iframe; safe to remove app-wide. */
export const STRIPE_DEV_TOOLS_IFRAME_TITLE = 'Stripe developer tools frame';

export const STRIPE_FLOATING_IFRAME_CLEANUP_INTERVAL_MS = 2000;

/** Heuristic max width/height (px) for floating button–style fixed iframes. */
export const STRIPE_FLOATING_IFRAME_MAX_EDGE_PX = 200;
